// libs
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";

// app
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { LoadingProvider } from "./_interceptors/loading.interceptor";
import { MwbScannerProvider } from './_models/mwbscanner'
import { AnalyticsProvider } from "./_interceptors/analytics.interceptor";


// app: components
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocalStorageProvider, SessionStorageProvider } from "./_services/session/session.service";
import { ServiceModule } from "./_services/service.module";
import { SharedModule } from "./_components/shared.module";

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ServiceModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule
  ],
  providers: [
    LoadingProvider, AnalyticsProvider, MwbScannerProvider, SessionStorageProvider, LocalStorageProvider],//BoardingPassButtonComponent
  bootstrap: [AppComponent],
})
export class AppModule { }
